"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWithHeader = fetchWithHeader;
var _constants = require("./constants");
var _appConfig = require("../config/app-config");
/* eslint-disable no-console */
/* eslint-disable filenames/match-regex */

const getTekcubValue = tekcubValue => {
  if (!tekcubValue || typeof tekcubValue !== 'string' || tekcubValue.trim() === '' || /[<>"'\s]/.test(tekcubValue)) {
    return null;
  }
  try {
    tekcubValue = decodeURIComponent(tekcubValue);
  } catch (error) {
    console.error('Failed to decode tekcubValue:', error);
    return null;
  }
  const parts = tekcubValue.split('|');
  const result = {};

  // Get all possible tekcub values
  const allTekcubValues = Object.values(_appConfig.TEKCUB_KEYS);
  const allTekcubKeys = Object.keys(_appConfig.TEKCUB_KEYS);

  // Process each part of the tekcub string
  for (const part of parts) {
    // Find which key this part belongs to
    const keyIndex = allTekcubValues.findIndex(value => part.startsWith(`${value}=`));
    if (keyIndex !== -1) {
      const keyName = allTekcubKeys[keyIndex];
      result[_appConfig.TEKCUB_KEYS[keyName]] = part;
    }
  }
  return Object.keys(result).length > 0 ? result : null;
};

/**
 * Processes a URL to handle tekcub parameter manipulation.
 *
 * @param {string} url The URL to process
 * @param {string} tekcubKey The key of the tekcub cookie to use
 * @returns {string} The processed URL with updated tekcub parameter
 */
function processTekcubUrl(url, tekcubKey) {
  // Convert URL object to string if needed
  const urlString = url instanceof URL ? url.toString() : url;
  const urlObj = new URL(urlString);
  const appParams = new URLSearchParams(urlObj.search);
  if (!appParams.has('tekcub')) {
    return urlString;
  }
  const tekcubValues = getTekcubValue(appParams.get('tekcub'));
  const regex = /[?&]tekcub=[^&]+/;

  // Replace directly in the url string to have = and not %3D
  let processedUrl = urlString;
  if (tekcubValues && tekcubValues[tekcubKey]) {
    const replacement = `tekcub=${tekcubValues[tekcubKey]}`;
    processedUrl = processedUrl.replace(regex, processedUrl.includes('?') ? `&${replacement}` : `?${replacement}`);
  } else {
    // If there is no replacement, delete the tekcub parameter
    appParams.delete('tekcub');
    urlObj.search = appParams.toString();
    processedUrl = urlObj.toString();
  }
  return processedUrl;
}

/**
 * Fetches data from a specified URL with custom headers.
 *
 * @param {string | URL} url The URL to fetch data from.
 * @param {object} options Additional options for the fetch request (default: {}).
 * @param {string} agentType The type of user agent (default: 'SWP').
 * @param {string} tekcubKey The key of the tekcub cookie to use (default: 'SWP').
 * @returns {Promise<Response>} A promise that resolves to the fetch response.
 */
function fetchWithHeader(url, options = {}, agentType = 'SWP', tekcubKey = _appConfig.TEKCUB_KEYS.SWP) {
  const userAgentString = _constants.USER_AGENTS[agentType];
  const headers = {
    'X-User-Agent': userAgentString,
    'X-App-Key': userAgentString,
    ...options.headers
  };
  const updatedOptions = {
    ...options,
    headers
  };
  url = processTekcubUrl(url, tekcubKey);
  return fetch(url, updatedOptions);
}